import { z } from 'zod'

import { fetchAccountsResponseSchema } from 'shared/api/common/schemas/applicationAccount'
import { installedApplicationSchema } from 'shared/api/common/schemas/installedApplication'

const installApplicationRequestSchema = z.object({ account_id: z.string(), app_hash: z.string() })

export const applicationInstallationSchemas = {
  installApplication: {
    request: installApplicationRequestSchema,
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
  fetchAccounts: {
    request: z.undefined(),
    response: z.object({ accounts: z.array(fetchAccountsResponseSchema) }),
    query: z.object({ app_id: z.number() }),
    path: z.undefined(),
  },
  fetchApplicationByHash: {
    request: z.undefined(),
    response: z.object({ app: installedApplicationSchema, hasSettings: z.boolean() }),
    query: z.object({ app_hash: z.string() }),
    path: z.undefined(),
  },
}
